import { render, staticRenderFns } from "./ExtrasContainer.vue?vue&type=template&id=573cc689"
import script from "./ExtrasContainer.vue?vue&type=script&lang=ts"
export * from "./ExtrasContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports